import { LocationVarKey } from "@swivl-mono/types";

import { IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { InputRow, PageHeader, SwitchRow, TextAreaRow, TextRow } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VBPName1,
  LocationVarKey.VBPDescription1,
  LocationVarKey.VBPName2,
  LocationVarKey.VBPDescription2,
  LocationVarKey.VBPName3,
  LocationVarKey.VBPDescription3
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Value Based Pricing
      </PageHeader>

      <InputRow {...page} marginTop label=" Tier 1 Name" keyName={LocationVarKey.VBPName1} />
      <TextAreaRow {...page} marginTop label=" Tier 1 Description" keyName={LocationVarKey.VBPDescription1} />

      <InputRow {...page} marginTop label=" Tier 2 Name" keyName={LocationVarKey.VBPName2} />
      <TextAreaRow {...page} marginTop label=" Tier 2 Description" keyName={LocationVarKey.VBPDescription2} />

      <InputRow {...page} marginTop label=" Tier 3 Name" keyName={LocationVarKey.VBPName3} />
      <TextAreaRow {...page} marginTop label=" Tier 3 Description" keyName={LocationVarKey.VBPDescription3} />
    </>
  );
}
